import 'babel-polyfill'
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App'
import router from './router'
import VueMeta from 'vue-meta'
import VueLazyload from 'vue-lazyload'
import { store } from './store/index'
import infiniteScroll from 'vue-infinite-scroll'
import { secureSS } from '@/assets/js/common.js'
import VueDaumPostcode from 'vue-daum-postcode'
import { NaviGuard } from '@/assets/js/naviGuard'
import VueSmoothScroll from 'vue2-smooth-scroll'
import i18n from '@/assets/lang'

const VueCookie = require('vue-cookie')
Vue.use(VueCookie)
Vue.use(VueDaumPostcode)

Vue.use(VueLazyload)

Vue.prototype.$IMP = window.IMP
Vue.prototype.$ss = secureSS

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})
Vue.use(infiniteScroll)

Vue.config.productionTip = false

Vue.filter('makeComma', val => {
  return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
})

Vue.filter('shortString', val => {
  if (val.length > 28) {
    return val.replace(val.substring(27), '')
  } else {
    return val
  }
})

Vue.use(VueSmoothScroll, {
  duration: 500,
  offset: -150
})

window.ENV = {}
window.ENV.$SERVICE_NAME_KO = process.env.VUE_APP_SERVICE_NAME_KO
window.ENV.$SERVICE_NAME_EN = process.env.VUE_APP_SERVICE_NAME_EN
window.ENV.Cor = {}
window.ENV.Cor.$NAME = process.env.VUE_APP_COR_NAME_KO
window.ENV.Cor.$NAME_EN = process.env.VUE_APP_COR_NAME_EN
window.ENV.Cor.$ADDRESS = process.env.VUE_APP_COR_ADDRESS
window.ENV.Cor.$CERT_NO = process.env.VUE_APP_COR_CERT_NUM
window.ENV.Cor.$SELLER_NO = process.env.VUE_APP_COR_SELLER_NUM
window.ENV.Cor.$PRESIDENT = process.env.VUE_APP_COR_PRESIDENT
window.ENV.Customer = {}
window.ENV.Customer.$TEL = process.env.VUE_APP_CUSTOMER_TEL
window.ENV.Customer.$MAIL = process.env.VUE_APP_CUSTOMER_MAIL
window.ENV.Customer.$CHARGE = process.env.VUE_APP_CUSTOMER_CHARGE
window.ENV.Customer.$CHARGE_TEL = process.env.VUE_APP_CUSTOMER_CHARGE_TEL
window.ENV.SNS = {}
window.ENV.SNS.KAKAO = {}
window.ENV.SNS.KAKAO.CLIENT_ID = process.env.VUE_APP_SNS_KAKAO_CLIENT_ID
window.ENV.SNS.KAKAO.CLIENT_SECRET = process.env.VUE_APP_SNS_KAKAO_CLIENT_SECRET
window.ENV.SNS.GOOGLE = {}
window.ENV.SNS.GOOGLE.CLIENT_ID = process.env.VUE_APP_SNS_GOOGLE_CLIENT_ID
window.ENV.SNS.FACEBOOK = {}
window.ENV.SNS.FACEBOOK.CLIENT_ID = process.env.VUE_APP_SNS_FACEBOOK_CLIENT_ID
window.ENV.SNS.NAVER = {}
window.ENV.SNS.NAVER.CLIENT_ID = process.env.VUE_APP_SNS_NAVER_CLIENT_ID
window.ENV.IMP = {}
window.ENV.IMP.MARKET_ID = process.env.VUE_APP_IMP_MAKRET_ID
window.ENV.IMP.PG = {}
window.ENV.IMP.PG.NAVER = process.env.VUE_APP_IMP_PG_NAVER
window.ENV.IMP.PG.KAKAO = process.env.VUE_APP_IMP_PG_KAKAO
window.ENV.IMP.PG.ETC = process.env.VUE_APP_IMP_PG_ETC
window.ENV.CHAT = {}
window.ENV.CHAT.LIVE = process.env.VUE_APP_CHAT_SERVER_LIVE
window.ENV.CHAT.VOD = process.env.VUE_APP_CHAT_SERVER_VOD
window.ENV.LANGUAGE = JSON.parse(process.env.VUE_APP_LANGUAGE_SET)

window.$i18n = i18n

NaviGuard(router)

Vue.config.productionTip = false
/* eslint-disable no-new */
export const app = new Vue({
  el: '#app',
  i18n,
  router,
  store,
  beforeCreate () {
    if (sessionStorage.getItem('accessToken')) {
      this.$store.dispatch('getUserInfo')
    }
    if (sessionStorage.getItem('accessToken')) {
      this.$store.dispatch('getUserInfoSns')
    }
  },
  components: { App },
  template: '<App/>',
  render: h => h(App)
}).$mount('#app')


